import getAuthenticatedClient from './AuthClient';

export async function getUserDetails(accessToken: string) {
    const client = getAuthenticatedClient(accessToken);
  
    const user = await client
      .api('/me')
      .select('displayName,userPrincipalName','employeeId')
      .get();
  
      //console.log(user);
    return user;
  }